/**
 * Metro error message mappings
 * Error codes follow pattern: M-XXX (Metro)
 */
export const ErrorMessages = {
  'M-001': 'Invalid request - Please select a device platform',
  'M-002': 'This platform is not supported',
  'M-003': 'Download failed - Please try again',
  'M-004': 'An unexpected error occurred - Please refresh and try again',
  'M-005': 'Network error - Please check your connection and try again',
};
